export const enum UserSignIn2InteractionEvent {
  /**
   * User clicked on sign in via facebook button
   */
  clickSignInFacebook = 'clickSignInFacebook',

  /**
   * User clicked on sign in via google button
   */
  clickSignInGoogle = 'clickSignInGoogle',

  /**
   * User clicked on log in button
   */
  clickLogIn = 'clickLogIn',
}
